import React from 'react';
import PropTypes from 'prop-types';

const PlaceholderWithIcon = ({ text, icon }) => (
  <div className="grid-x" style={{ padding: '18px' }}>
    <span className="cell auto ellipsis">{text}</span>
    <span className="cell shrink gray-400"><i className="material-icons">{icon}</i></span>
  </div>
);

PlaceholderWithIcon.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
};

PlaceholderWithIcon.defaultProps = {
  text: 'Search..',
  icon: 'search',
};

export default PlaceholderWithIcon;



// WEBPACK FOOTER //
// ./js/src/components/image_search/Common.jsx